export default __webpack_public_path__ + "static/media/Group 140.f704c879.png";